const table = [
    {
        prop: 'Region',
        label: 'Región',
        minWidth: 100
    },
    {
        prop: 'Depart_Code',
        label: 'Cod. Dpto.',
        minWidth: 100
    },    
    {
        prop: 'Depart_Nombre',
        label: 'Departamento',
        minWidth: 150
    },
    {
        prop: 'Municipio_Code',
        label: 'Cod. Munic.',
        minWidth: 100
    },    
    {
        prop: 'Municipio',
        label: 'Municipio',
        minWidth: 150
    },
    {
        prop: 'IDPunto',
        label: 'ID Punto',
        minWidth: 150
    },
    {
        prop: 'Cedula',
        label: 'Cédula',
        minWidth: 150
    },
    {
        prop: 'Nombres',
        label: 'Cliente',
        minWidth: 150
    },
    {
        prop: 'FechaContabilizacion',
        label: 'Fecha Contabilización',
        minWidth: 150
    }
]

const table_plus = [
    {
        prop: 'Barrio',
        label: 'Barrio',
        minWidth: 100
    },    
    {
        prop: 'Direccion',
        label: 'Dirección',
        minWidth: 150
    },
    {
        prop: 'Estrato',
        label: 'Estrato',
        minWidth: 150
    },
    {
        prop: 'NumeroDoc',
        label: 'Cédula',
        minWidth: 100
    },    
    {
        prop: 'ItemCode',
        label: 'Código',
        minWidth: 150
    },
    {
        prop: 'dscription',
        label: 'Descripción',
        minWidth: 150
    },
    {
        prop: 'Series',
        label: 'Series',
        minWidth: 150
    },
    {
        prop: 'TaxCode',
        label: 'Código Tax',
        minWidth: 150
    },
    {
        prop: 'FechaVencimiento',
        label: 'Fecha Vencimiento',
        minWidth: 150
    },
    {
        prop: 'Documento',
        label: 'Fecha Documento',
        minWidth: 150
    }
]

export default [table, table_plus]
